export const PRODUTO_INSUMO_CATEGORIA_ENUM = [
    {
        id: 'DEFENSIVO',
        descricao: "Defensivo",
        idBD: 0
    },
    {
        id: 'FERTILIZANTE',
        descricao: "Fertilizante",
        idBD: 1
    },
    {
        id: 'CULTIVAR',
        descricao: "Cultivar",
        idBD: 2
    },
    {
        id: 'COMBUSTIVEL',
        descricao: "Combustível",
        idBD: 3
    },
    {
        id: 'ITEM',
        descricao: "Item",
        idBD: 4
    },
    {
        id: 'OUTROS',
        descricao: "Outros",
        idBD: 5
    },
];